import { type ApiCoreContextValue } from "contexts";
import makeAuditLogResolver from "./auditLog";
import makeDataRoomAttestationSpecsResolver from "./dataRoomAttestationSpecs";

export const makeQueryResolvers = (
  client: ApiCoreContextValue["client"],
  sessionManager: ApiCoreContextValue["sessionManager"],
  store: ApiCoreContextValue["store"]
) => ({
  auditLog: makeAuditLogResolver(client, sessionManager, store),
  dataRoomAttestationSpecs: makeDataRoomAttestationSpecsResolver(
    client,
    sessionManager,
    store
  ),
});
